import { extend } from 'vee-validate'
import { length } from 'vee-validate/dist/rules'

// Length rule
extend('length', {
  ...length,
  message: 'Pole musi składać się z {length} znaków'
})
